export default {
	props: {
		value: {
			type: [String, Object, Number, Boolean],
		},
		bold: Boolean,
	}
};